ike-dropdown {
  .dropdown {
    background-color: $white;
    background-color: var(--white);
    border-radius: 4px;
    box-shadow: 0 0 20px 0 rgba(0,0,0,0.15);
    color: $gray-medium;
    color: var(--gray-medium);
    letter-spacing: 0;
    line-height: 21px;
    min-width: 140px;
    z-index: 1;

    &__link {
      display: flex;
      cursor: pointer;
      padding: 10px 15px 10px 15px;

      &:hover {
        background-color: $gray-extra-light;
        background-color: var(--gray-extra-light);
      }

      &:last-child {
        margin-bottom: 0;
      }

      img {
        width: 30px;

        &:first-of-type {
          margin-right: 10px;
        }
      }

      button:first-of-type {
        margin-right: 10px;
      }

      .link-display, a {
        display: flex;
        align-items: center;

        i {
          margin-right: 10px;
        }
      }
    }

    &__icon {
      font-size: 16px !important;
      margin-right:10px !important;
    }

    &__text {
      margin-left:0 !important;
    }
  }

  .trigger{
    cursor: pointer;
  }

  [slot=content] {
    display: flex;
    flex-direction: column;
  }

  #arrow, #arrow::before {
    height: 8px;
    position: absolute;
    width: 8px;
    z-index: -1;
  }

  #arrow::before {
    background: $white;
    background: var(--white);
    content: '';
    transform: rotate(45deg);
  }

  .dropdown[data-popper-placement^='top'] > #arrow {
    bottom: -4px;
  }

  .dropdown[data-popper-placement^='bottom'] > #arrow {
    top: -4px;
  }

  .dropdown[data-popper-placement^='left'] > #arrow {
    right: -4px;
  }

  .dropdown[data-popper-placement^='right'] > #arrow {
    left: -4px;
  }

  .dropdown {
    display: none;
    pointer-events: none;
    position: absolute;
    &.opened {
      display: block;
      pointer-events: all;
    }
  }

}
